/**
 * 고객 - 기본정보 타입
 */
export interface UploadedFile extends File {
    fileOrgname?: string;
    fileId?: number;
    fileUrl?: string;
    fileKey?: string;
    accountId?: string;
    fileType?: string;
}

export interface BasicClientInfoType {
    accountId: string;
    billingFlag: string;
    businessRegNo: string;
    customerCategory: string;
    customerType: string;
    industryCategory: string;
    location: string;
    name: string;
    newDTotCredit: number | null;
    newIDtRcpDd: number | null;
    newLAccountErpValue: string;
    newLIndustryGlobalValue: string;
    newPCustomerCategory: number;
    newPCustomerType: number;
    newPFgBill: string | number | null;
    newPLocation: number;
    newPTpRcpDd: number | null;
    newTxtCdPartner: string;
    newTxtDcAds1D: string;
    newTxtDcAds1H: string;
    newTxtNameEng: string;
    newTxtNmCeo: string;
    newTxtNmPartner: string;
    newTxtNoTel: null | string;
    parentAccount: string;
    parentAccountIdValue: string | null;
    receiptType: string;
    tierInfo: string;
    createName?: string;
    createdon?: string;
    businessFileInfo?: {
        fileOrgname?: string;
    } | null;
    newTxtTpJob?: string | null;      // 내부수정: 업태 (ERP 연동)
    newTxtClsJob?: string | null;     // 내부수정: 종목 (ERP 연동)
    newTxtNoCompany?: string | null;  // 내부수정: 사업자등록번호 (ERP 연동)
}

/**
 * 거래처 출하 정보 request type
 */
export interface SearchAccountReqType {
    accountId: string;
    chargeName: string;
    customerCategoryName: string;
    defaultContact: string;
    erpAccountName: string;
    industryCategory: string;
    name: string;
}

/**
 * 거래처 출하 정보 res type
 */
export interface SearchAccountType {
    accountId: string;
    accountShipmentInfoId: number;
    addressName: string;
    application: string;
    applicationName: string;
    contactPerson: string;
    contactPersonName: string;
    deliveryPlace: string;
    deliveryPlaceName: string;
    exchangeRateCondition1: 0;
    exchangeRateCondition2: 0;
    exchangeRateCondition3: 0;
    exchangeRateUnit: 0;
    industryCategory: string;
    industryName: string;
    memo: string;
    orderType: string;
    orderTypeName: string;
    recipient: string;
    recipientName: string;
    recipientMobilephone: string;
    regAt: Date;
    regBy: string;
    salesPlace: string;
    salesPlaceName: string;
    shippingAddress: string;
    taxChargeName: string;
    taxInvoicePerson: string;
    taxChargeMobilePhone: string;
    taxChargeEmailAddress: string;
    expectedReceiptDate: string;
    vatType: string;
    vatTypeName: string;
    address1?: string; //
    address2?: string; //
    wonUnit?: 0;
    newTxtNmPartner?: string;
    newTxtCdPartner?: string;
    newLAccountErpValue?: string;
    newPFgBill?: string | null;
    newDTotCredit?: number | null;
    newTxtNmCeo?: string;
    newPTpRcpDd?: string | null;
    newTxtNoTel?: string | null;
    newIDtRcpDd?: string | null;
    newTxtDcAds1H?: string;
    newTxtDcAds1D?: string;
    endType: string
    newTxtNote: string // 기타사항(거래명세서 비고)
    newTxtCollection: string // 수금메모(세금계산서 비고)
}

/**
 * 거래처 연락처 정보 Map res type
 */
export interface SearchAccountContactMapResType {
    totalCount: number;
    SearchAccountAddressRes: SearchAccountContactResType[];
}

/**
 * 거래처 연락처 정보 res type
 */
export interface SearchAccountContactResType {
    department: string;
    emailAddress1: string;
    fullName: string;
    industryName: string;
    jobTitle: string;
    mobilePhone: string;
    newTxtTeam: string;
    stateCode: string;
    telephone1: string;
    contactid: string;
}

/**
 * 거래처 계정 주소 정보 res type
 */
export interface SearchAddressMapResType {
    totalCount: number;
    SearchAccountAddressRes: SearchAddressResType[];
}

/**
 * 거래처 계정 주소 정보 res type
 */
export interface SearchAddressResType {
    _createdby_value: string;
    _modifiedby_value: string;
    _new_l_customer_value: string;
    _ownerid_value: string;
    _owningbusinessunit_value: string;
    _owningteam_value: string;
    createdon: string;
    importsequencenumber: number;
    modifiedon: string;
    new_addressid: string;
    new_name: string;
    newName: string;
    createName: string;
    new_txt_line1: string;
    new_txt_line2: string;
    new_txt_postalcode: string;
    new_txt_seq: string;
    overriddencreatedon: string;
    statecode: number;
    statuscode: number;
    timezoneruleversionnumber: number;
    utcconversiontimezonecode: number;
    versionnumber: number;
}

/**
 * 주소 타입
 */
export interface AddressResType {
    new_addressid: string;
    newName: string;
    new_txt_line1: string;
    new_txt_line2: string;
    new_txt_postalcode: string;
    createdon: string;
    statuscode: string;
    createName: string;
    customerName: string;  // 내부수정: 관련 거래처
    _new_l_customer_value: string; // 내부수정: 관련 거래처 ID 추가
}

export interface AddressResMapType {
    addressList: AddressResType[];
    totalCount: number;
}

// 파일 정보 타입
export interface AccountFileVOType {
    fileId?: number;
    fileUrl?: string;
    fileKey?: string;
    fileOrgname: string;
    accountId?: string;
    fileType?: string;
}

// 기본 계층 정보 타입
export interface BasicTierInfoType {
    claNumber: string;
    companyId: string;
    parentCompanyId: string | null;
    companyLegalName: string;
    erpAccountName: string;
    accountFileVO: AccountFileVOType;
    accountId?: string;
}

// 계층 리스트 아이템 타입
export interface TierListItemType {
    ptaTierId: number;
    claNumber: string;
    companyId: string;
    erpAccountName: string;
    parentCompanyId: string;
    pricingGroup: string;
    vlookup: string;
    companyLegalName: string;
    priceTier: string;
    erpCode: string;
    charge: string;
    regAt: string;
    outDateFlag: string;
    standard: string
}

/**
 * 거래처 티어 정보 타입
 */
export interface SearchTierInfoResType {
    basicTierInfo: BasicTierInfoType;
    tierList: TierListItemType[];
}

/**
 * erp 거래처 검색 타입
 */
export interface SearchErpAccountResType {
    newTxtNmCeo: string | null; // 대표자
    newTxtNoTel: string | null; // 대표번호
    newErpAccountId?: string | undefined; // ERP 계정 ID (Primary Key)
    newTxtNmPartner?: string | null; // 파트너 이름
    new_erp_accountid?: string | null | undefined;
    new_txt_nm_partner?: string | null;
    newTxtCdPartner?: string;
    newTxtDcAds1H?: string;
    newTxtDcAds1D?: string | null;
    newPFgBill?: string | null | number;
    billingFlag?: string | null;
    newPTpRcpDd?: number;
    receiptType?: string;
    newIDtRcpDd?: number | null;
    newDTotCredit?: number | null;
    newTxtNoCompany?: string | null;
    newTxtTpJob?: string | null;   // 내부수정: 업태
    newTxtClsJob?: string | null;  // 내부수정: 종목
}

export interface SearchErpAccountResMapType {
    erpAccountList: SearchErpAccountResType[];
    totalCount: number;
}

/**
 * 시스템 사용자 res type
 */
export interface SystemUserType {
    systemuserid: string;
    fullname: string;
    internalemailaddress: string;
}

export interface SystemUserMapType {
    systemUserList: SystemUserType[];
    totalCount: number;
}

/**
 * 이전결제건
 */
export interface Shipment {
    newShipmentId: string;
    newDtOrder: string;
    orderNo: string | null;
    orderSubjectResList: OrderSubject[];
}

export interface OrderSubject {
    newTxtNmItem: string;
    currencyName: string | null;
    _new_l_shipment_value: string;
    new_shipment_subjectid: string;
    new_p_currency: string | null;
    new_d_unitprice: number;
    new_d_exchange_rate: number | null;
    new_d_won: number;
    new_d_total: number;
    _new_l_erp_product_value: string;
    new_txt_standard: string;
    new_i_qty: number;
}

export interface CreateAddress {
    _new_l_customer_value: string;
    createName: string;
    createdByValue: string;
    createdon: string;
    newName: string;
    new_addressid: string;
    new_txt_line1: string;
    new_txt_line2: string;
    new_txt_postalcode: string;
    statecode: number;
    statuscode: string;
}

export interface PostCustomerAccountReadPtaTotalListApiForm {
    keyword: string | null;
    keywordType: string;
    itemName: string;
    partNo: string;
    limit: number;
    pageNo: number;
    searchMonth: string;
}

export const defaultPostCustomerAccountReadPtaTotalListApiForm: PostCustomerAccountReadPtaTotalListApiForm = {
    keyword: '',
    keywordType: '1',
    itemName: '',
    partNo: '',
    limit: 10,
    pageNo: 1,
    searchMonth: ''
}